import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef } from "@angular/core";
import { AppService } from "@api";
import { HeaderEnum, RespuestaEstatusEnum, TipoAccionEvaluacionEnum } from "@enumeraciones/Enumeraciones.enum";
import { DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { EjecucionEvaluacionEliminacionComponent } from "./ejecucionevaluacioneliminacion/ejecucionevaluacioneliminacion.component";


@Component(
  {
      selector: 'EjecucionEvaluacion',
      templateUrl: './ejecucionevaluacion.component.html',
      styleUrls: ['./ejecucionevaluacion.component.scss']
  })

export class EjecucionEvaluacionComponent implements AfterViewInit {

  listaperiodoevaluacion:any[] = [];
  SelDataPeriodoporTipo:any[] = [];
  Date: Date = new Date();
  periodoevaluacion: number = 0;

  consulta!: boolean;

  @ViewChild("administrareliminacion", {read: ViewContainerRef}) administrareliminacion!: ViewContainerRef;

  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

}

  ngAfterViewInit(){
    this.Periodoevaluacion();
  }

  Periodoevaluacion(){
    this.appService.Post("planeacion/periodoevaluacion/buscar",{}).then(res =>{
        if(res.status == RespuestaEstatusEnum.Success){
            this.listaperiodoevaluacion = res.data;
        }
    })
  }

  tipoevaluacion(id:any){
    if(id){
      this.appService.Post("evaluacionpendiente/configuracion/periodoportipo", {"periodoevaluacionid": id, "periodoevaluacionfiltroid": id}).then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
            for (let datos of res.data) {
                datos.fechainicioevaluacion = new Date(datos.fechainicioevaluacion + "T00:00:00")
            }
            this.SelDataPeriodoporTipo = res.data
        }
    })
    }else{
      this.SelDataPeriodoporTipo = [];
      this.periodoevaluacion = 0;
    }
  }

  crearevaluaciones(id:any){
    let tipoevaluacionid = this.SelDataPeriodoporTipo.find(x=>x.periodoevaluacionportipoevaluacionid == id).tipoevaluacionid;
    let nombretipo = this.SelDataPeriodoporTipo.find(x=>x.periodoevaluacionportipoevaluacionid == id).nombre;
    let opciones = this.sistemaService.GetOpcionesAceptar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Se inicio la creación de las evaluaciones para. ' + nombretipo +"<br> ¿Desea continuar?", opciones).then(res => {
          if (res == 1) {
            this.editarevaluacion(id, TipoAccionEvaluacionEnum.Agregar, tipoevaluacionid, false).then(res =>{
              if(res){
                this.correrevaluaciones(tipoevaluacionid);
                setTimeout(() => {
                  this.tipoevaluacion(this.periodoevaluacion);
                }, 400);
              }
            });
          }
      })

  }

  actualizarevaluaciones(id:any){
    let tipoevaluacionid = this.SelDataPeriodoporTipo.find(x=>x.periodoevaluacionportipoevaluacionid == id).tipoevaluacionid;
    let opciones = this.sistemaService.GetOpcionesConfirmar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Esta acción actualizará las evaluaciones existentes, esto puede tomar varios minutos, es recomendable que los usuarios no estén contestando las evaluaciones. <br> ¿Deseas continuar?', opciones).then(res => {
      if (res == 1) {
        this.editarevaluacion(id, TipoAccionEvaluacionEnum.Actualizar, tipoevaluacionid, false).then(res => {
          if(res){
            this.correrevaluaciones(tipoevaluacionid);
            setTimeout(() => {
              this.tipoevaluacion(this.periodoevaluacion);
            }, 300);
          }
        });
      }
  })
  }

  reiniciarevaluaciones(id:any){
    let tipoevaluacion = this.SelDataPeriodoporTipo.find(x=>x.periodoevaluacionportipoevaluacionid == id);
    this.consulta = true;
    this.administrareliminacion.clear();
    const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(EjecucionEvaluacionEliminacionComponent);
    var ref: ComponentRef<any> = this.administrareliminacion.createComponent(factory);
    ref.instance.tipoevaluacion = tipoevaluacion;
    ref.instance.output.subscribe((cambio: boolean) => {
        this.consulta = false;
        ref.destroy();
    });
  }

  editarevaluacion(id:number, accion:number, tipoevaluacionid:number, actualizar:boolean){
    return new Promise((resolve : any) =>{
      this.appService.Post("evaluacionpendiente/configuracion/periodoportipoeditar", {"id":id, "accion":accion}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          if(actualizar){
            this.correrevaluaciones(tipoevaluacionid);
            setTimeout(() => {
              this.tipoevaluacion(this.periodoevaluacion);
            }, 200);
          }
          return resolve(true);
        }else{
          return resolve(false);
        }
      })
    })
  }

  correrevaluaciones(id:number){
    let totalurl = "evaluacionpendiente/?tipoevaluacionid[]="+id;
    this.appService.Get(totalurl, [HeaderEnum.NoShowLoading]).then(res=>{

    });
  }

  EliminacionGeneral(periodoid:number){
    let opciones = this.sistemaService.GetOpcionesConfirmar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Esta acción actualizará las evaluaciones existentes, lo cual puede tardar varios minutos. Se recomienda que los usuarios no respondan evaluaciones durante el proceso para evitar interrupciones. <br> ¿Deseas continuar?', opciones).then(res => {
      if (res == 1) {
        this.appService.Post('evaluacionpendiente/configuracion/eliminarevaluacionesgeneral', {"id":periodoid}, [HeaderEnum.NoShowLoading]).then(response =>{
          //this.tipoevaluacion(this.periodoevaluacion);
        })
      }
    })
  }

  mostrarInfo(){
    let opciones = this.sistemaService.GetOpcionesSalirEvaluacion();
    let mensaje = `
    <div style="text-align: left; line-height: 1.6;">
      <h4 style="color: #1976d2; margin-bottom: 15px;">Información sobre los botones de acción:</h4>

      <div style="margin-bottom: 15px;">
        <p><strong>Crear:</strong> Genera las evaluaciones para el período y tipo de evaluación seleccionado.</p>
        <p><strong>Actualizar:</strong> Genera evaluaciones faltantes o nuevas evaluaciones, pero NO puede eliminar evaluaciones ya existentes.</p>
        <p><strong>Administrar eliminación:</strong> Abre una pantalla donde puedes ver todas las evaluaciones y eliminar las que se requieran.</p>
        <p><strong>Eliminar todas las evaluaciones:</strong> Elimina TODAS las evaluaciones existentes dentro del período de evaluación seleccionado.</p>
      </div>

      <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px; padding: 10px; margin-top: 15px;">
        <strong style="color: #856404;">Advertencia importante:</strong>
        <span style="color: #856404;">Si existen evaluaciones ya contestadas, se perderán de forma permanente al usar las funciones de eliminación.</span>
      </div>
    </div>
    `;

    this.mensajeService.Dialogo(DialogoEnum.aviso, '', mensaje, opciones).then(res => {
      if (res == 1) {
      }
    })
  }

}



